import { render } from "./gameBet.vue?vue&type=template&id=0288c4ae&scoped=true"
import script from "./gameBet.vue?vue&type=script&lang=js"
export * from "./gameBet.vue?vue&type=script&lang=js"

import "./gameBet.vue?vue&type=style&index=0&id=0288c4ae&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/xz_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0288c4ae"]])

export default __exports__